import type { GetServerSideProps } from "next";

import { loadPageWithGlobal } from "@shared/api";

import { getCafesRestaurantsPointPage } from "@/_pages/cafes-restaurants/api";
import { SingleCafesRestaurantsPointPage } from "@/_pages/cafes-restaurants/ui";

type Params = {
  slug: string;
};

type PageCms = Awaited<ReturnType<typeof getCafesRestaurantsPointPage>>;

type PageProps = {
  cms: PageCms;
};

const Page = (props: PageProps) => {
  const { cms } = props;
  const { point, mapData } = cms || {};

  return <SingleCafesRestaurantsPointPage point={point} mapData={mapData} />;
};

export const getServerSideProps: GetServerSideProps<
  Record<string, unknown>,
  Params
> = async (context) => {
  const { res } = context;
  const slug = context.params?.slug;

  if (!slug) {
    return { notFound: true };
  }

  return await loadPageWithGlobal(
    async () => {
      const { point, mapData, seo } = await getCafesRestaurantsPointPage(slug);

      return {
        point,
        mapData,
        seo,
      };
    },
    { res },
  );
};

export default Page;
